import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCustomerNameQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
}>;


export type GetCustomerNameQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerStateData', customerId: string, name: string } | null };

export type GetItemNameQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
}>;


export type GetItemNameQuery = { __typename?: 'Query', item?: { __typename?: 'ItemStateData', itemId: string, name: string } | null };

export type GetOrderQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', revision?: number | null, tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit: Types.PriceEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, program?: string | null, orderKindId?: string | null, orderKindName?: string | null, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', counterpartOrderId: string, role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', unitPrice: number, overrideUnitPrice?: number | null, acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, pulls: Array<{ __typename?: 'OrderLinePull', pullId: string, lineItemId: string, itemId: string, locationId: string, locationName?: string | null, grade: number, quantity: number, pulledBy: string, pulledAt: Types.TDateISO }>, allocationTakes: Array<{ __typename?: 'OrderAllocationTake', lineItemId: string, itemId: string, itemName?: string | null, locationId: string, locationName?: string | null, grade: number, quantity: number, direction: Types.AllocationTakeDirection, otherOrderId: string, otherOrderNumber?: string | null, otherCustomerName?: string | null, allocatedBefore?: number | null, allocatedAfter?: number | null, takenBy: string, takenAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null };

export type GetOrderPriceEntryUnitQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderPriceEntryUnitQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', orderId: string, priceEntryUnit: Types.PriceEntryUnit } | null };

export type GetOrderLineCurrenciesQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderLineCurrenciesQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', orderId: string, lineItems: Array<{ __typename?: 'LineItemData', currency: string }> } | null };

export type GetOrderStatusQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderStatusQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', orderId: string, status: Types.OrderStatus } | null };

export type GetOrderHistoryQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderHistoryQuery = { __typename?: 'Query', orderHistory: Array<{ __typename?: 'OrderHistoryRecord', id: string, label: string, occurredAt: Types.TDateISO, occurredBy?: string | null }> };

export type GetOrderInspectionQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderInspectionQuery = { __typename?: 'Query', orderInspection: { __typename?: 'OrderInspectionPayload', outcome: Types.OrderInspectionOutcome, order?: { __typename?: 'OrderStateData', orderId: string, orderNumber: string, type: Types.OrderType, creditedFromOrderId?: string | null, correction?: { __typename?: 'OrderCorrectionData', counterpartOrderId: string, newCustomerId: string, role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null } | null } };

export type GetOrderRouteInspectionQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderRouteInspectionQuery = { __typename?: 'Query', orderInspection: { __typename?: 'OrderInspectionPayload', outcome: Types.OrderInspectionOutcome, order?: { __typename?: 'OrderStateData', orderId: string, route: string } | null } };

export type GetOrderNumbersForHistoryQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrderNumbersForHistoryQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrderDepositStatusQueryVariables = Types.Exact<{
  where: Types.OrdersDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetOrderDepositStatusQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, depositRequired: number, depositReceived: number, depositSatisfied: boolean, allocationStatus?: Types.OrderAllocationStatus | null, lastAllocatedDate?: Types.TDateISO | null }> | null } | null };

export type OrderAllocationDepositFragment = { __typename?: 'OrdersDocument', depositRequired: number, depositReceived: number, depositSatisfied: boolean };

export type GetOrdersForAllocationMoveQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrdersForAllocationMoveQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', id: string, tenantId: string, orderId: string, orderNumber: string, poNumber: string, customerId: string, customerName: string, initializedDate: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, shippedDate?: Types.TDateISO | null, orderStatus: Types.OrderStatus, numberOfLines: number, paymentStatus: Types.PaymentStatus, freightChargeType?: number | null, freightChargeValue?: number | null, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, freightSource: Types.FreightSource, freightChargeReason: string, salesPerson?: string | null, syncDate?: Types.TDateISO | null, erpId?: string | null, orderType: Types.OrderType, orderEntryUnit: Types.OrderEntryUnit, finalCredit: boolean, termsId?: string | null, history: Array<string>, itemIds: string, adjustedAt: Types.TDateISO, adjustedBy: string, discountPercent: number, discountReason: string, depositRequired: number, depositReceived: number, depositSatisfied: boolean, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, subtotal?: { __typename?: 'MoneyData', currency: string, amount: number } | null, amountPaid?: { __typename?: 'MoneyData', currency: string, amount: number } | null, balance?: { __typename?: 'MoneyData', currency: string, amount: number } | null, freightChargeAmount?: { __typename?: 'MoneyData', currency: string, amount: number } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceDocument', contributions: Array<{ __typename?: 'LoadFreightContributionDocument', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, discountAmount: { __typename?: 'MoneyData', currency: string, amount: number } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrdersForKitOrderImportQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrdersForKitOrderImportQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string, poNumber: string, customerName: string, orderStatus: Types.OrderStatus, shipFromSiteLocationId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type EffectiveOrderNoteFragment = { __typename?: 'EffectiveOrderNote', context: Types.NoteContext, source: Types.EffectiveNoteSource, text?: string | null };

export type GetOrderEffectiveNotesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrderEffectiveNotesQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, effectiveNotes: Array<{ __typename?: 'EffectiveOrderNote', context: Types.NoteContext, source: Types.EffectiveNoteSource, text?: string | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrderPaymentsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrderPaymentsQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', id: string, orderId: string, orderType: Types.OrderType, creditApplicationStatus?: Types.CreditApplicationStatus | null, paymentStatus: Types.PaymentStatus, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, amountPaid?: { __typename?: 'MoneyData', currency: string, amount: number } | null, balance?: { __typename?: 'MoneyData', currency: string, amount: number } | null, payments: Array<{ __typename?: 'OrderPaymentEntryDocument', kind: Types.OrderPaymentKind, source: Types.OrderPaymentSource, externalRemoteId?: string | null, occurredAt: Types.TDateISO, recordedBy?: string | null, paymentId?: string | null, paymentSyncStatus: Types.PaymentSyncStatus, accountingPaymentId?: string | null, syncFailureReason?: string | null, amount: { __typename?: 'MoneyData', currency: string, amount: number } }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrderCreditsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrderCreditsQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', id: string, orderId: string, orderType: Types.OrderType, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, credits: Array<{ __typename?: 'OrderCreditEntry', creditOrderId: string, creditOrderNumber: string, creditedAt: Types.TDateISO, reason?: string | null, amount: { __typename?: 'MoneyData', currency: string, amount: number } }>, creditedTotal: { __typename?: 'MoneyData', currency: string, amount: number }, netAfterCredits?: { __typename?: 'MoneyData', currency: string, amount: number } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type OrderCorrectionLinkFragment = { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string };

export type OrderCreditsFragment = { __typename?: 'OrdersDocument', id: string, orderId: string, orderType: Types.OrderType, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, correction?: { __typename?: 'OrderCorrectionData', role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, credits: Array<{ __typename?: 'OrderCreditEntry', creditOrderId: string, creditOrderNumber: string, creditedAt: Types.TDateISO, reason?: string | null, amount: { __typename?: 'MoneyData', currency: string, amount: number } }>, creditedTotal: { __typename?: 'MoneyData', currency: string, amount: number }, netAfterCredits?: { __typename?: 'MoneyData', currency: string, amount: number } | null };

export type GetLineItemActualQuantitiesQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetLineItemActualQuantitiesQuery = { __typename?: 'Query', lineItemActualQuantities: Array<{ __typename?: 'LineItemActualQuantityDocument', orderId: string, lineItemId: string, itemId: string, locationId?: string | null, grade?: number | null, availableQuantity: number, reservedQuantity: number, actualQuantity: number }> };

export type GetLineItemActualQuantitiesByLocationGradeQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetLineItemActualQuantitiesByLocationGradeQuery = { __typename?: 'Query', lineItemActualQuantitiesByLocationGrade: Array<{ __typename?: 'LineItemActualQuantityDocument', orderId: string, lineItemId: string, itemId: string, locationId?: string | null, grade?: number | null, availableQuantity: number, reservedQuantity: number, actualQuantity: number }> };

export type GetLocationsByIdsQueryVariables = Types.Exact<{
  where: Types.LocationDocumentFilterInput;
}>;


export type GetLocationsByIdsQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationsConnection', nodes?: Array<{ __typename?: 'LocationDocument', id: string, name: string }> | null } | null };

export type GetOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', id: string, tenantId: string, orderId: string, orderNumber: string, poNumber: string, customerId: string, customerName: string, initializedDate: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, shippedDate?: Types.TDateISO | null, orderStatus: Types.OrderStatus, numberOfLines: number, paymentStatus: Types.PaymentStatus, freightChargeType?: number | null, freightChargeValue?: number | null, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, freightSource: Types.FreightSource, freightChargeReason: string, salesPerson?: string | null, syncDate?: Types.TDateISO | null, erpId?: string | null, orderType: Types.OrderType, orderEntryUnit: Types.OrderEntryUnit, finalCredit: boolean, termsId?: string | null, history: Array<string>, itemIds: string, adjustedAt: Types.TDateISO, adjustedBy: string, discountPercent: number, discountReason: string, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, subtotal?: { __typename?: 'MoneyData', currency: string, amount: number } | null, amountPaid?: { __typename?: 'MoneyData', currency: string, amount: number } | null, balance?: { __typename?: 'MoneyData', currency: string, amount: number } | null, freightChargeAmount?: { __typename?: 'MoneyData', currency: string, amount: number } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceDocument', contributions: Array<{ __typename?: 'LoadFreightContributionDocument', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, discountAmount: { __typename?: 'MoneyData', currency: string, amount: number } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrdersGridListQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetOrdersGridListQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', id: string, orderId: string, orderNumber: string, poNumber: string, customerId: string, customerName: string, initializedDate: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, shippedDate?: Types.TDateISO | null, orderStatus: Types.OrderStatus, numberOfLines: number, freightChargeType?: number | null, freightChargeValue?: number | null, salesPerson?: string | null, syncDate?: Types.TDateISO | null, erpId?: string | null, orderType: Types.OrderType, finalCredit: boolean, termsId?: string | null, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, subtotal?: { __typename?: 'MoneyData', currency: string, amount: number } | null, freightChargeAmount?: { __typename?: 'MoneyData', currency: string, amount: number } | null, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrderLocationsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Array<Types.LocationsSalesPersonDocumentSortInput> | Types.LocationsSalesPersonDocumentSortInput>;
  where?: Types.InputMaybe<Types.LocationsSalesPersonDocumentFilterInput>;
}>;


export type GetOrderLocationsQuery = { __typename?: 'Query', locationsSalesPeople?: { __typename?: 'LocationsSalesPeopleConnection', totalCount: number, nodes?: Array<{ __typename?: 'LocationsSalesPersonDocument', id: string, tenantId: string, customerId: string, locationId: string, name: string, erpId: string, code: string, salesPersonEmails: Array<string> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetLocationSalesPeopleQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Array<Types.LocationsSalesPersonDocumentSortInput> | Types.LocationsSalesPersonDocumentSortInput>;
  where?: Types.InputMaybe<Types.LocationsSalesPersonDocumentFilterInput>;
}>;


export type GetLocationSalesPeopleQuery = { __typename?: 'Query', locationsSalesPeople?: { __typename?: 'LocationsSalesPeopleConnection', totalCount: number, nodes?: Array<{ __typename?: 'LocationsSalesPersonDocument', id: string, tenantId: string, customerId: string, locationId: string, name: string, erpId: string, code: string, salesPersonEmails: Array<string> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrderDetailsPdfQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderDetailsPdfQuery = { __typename?: 'Query', orderDetailsPdf?: { __typename?: 'OrderDetailsPdfData', base64Pdf: string, orderId: string } | null };

export type GetShippingAcknowledgmentPdfQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetShippingAcknowledgmentPdfQuery = { __typename?: 'Query', shippingAcknowledgmentPdf?: { __typename?: 'OrderDetailsPdfData', base64Pdf: string, orderId: string } | null };

export type GetOrderAddressEditPermissionsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
  locationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type GetOrderAddressEditPermissionsQuery = { __typename?: 'Query', orderAddressEditPermissions: { __typename?: 'OrderAddressEditPermissions', billingAddressEditable: boolean, locationAddressEditable: boolean } };

export type OrderCustomerLocationPoRequiredInheritedQueryVariables = Types.Exact<{
  locationId: Types.Scalars['UUID']['input'];
}>;


export type OrderCustomerLocationPoRequiredInheritedQuery = { __typename?: 'Query', customerLocationPoRequiredInherited: boolean };

export type LocationSalesPersonDetailsFragment = { __typename?: 'LocationsSalesPersonDocument', id: string, tenantId: string, customerId: string, locationId: string, name: string, erpId: string, code: string, salesPersonEmails: Array<string> };

export type OrderSummaryFragment = { __typename?: 'OrdersDocument', id: string, tenantId: string, orderId: string, orderNumber: string, poNumber: string, customerId: string, customerName: string, initializedDate: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, shippedDate?: Types.TDateISO | null, orderStatus: Types.OrderStatus, numberOfLines: number, paymentStatus: Types.PaymentStatus, freightChargeType?: number | null, freightChargeValue?: number | null, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, freightSource: Types.FreightSource, freightChargeReason: string, salesPerson?: string | null, syncDate?: Types.TDateISO | null, erpId?: string | null, orderType: Types.OrderType, orderEntryUnit: Types.OrderEntryUnit, finalCredit: boolean, termsId?: string | null, history: Array<string>, itemIds: string, adjustedAt: Types.TDateISO, adjustedBy: string, discountPercent: number, discountReason: string, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, subtotal?: { __typename?: 'MoneyData', currency: string, amount: number } | null, amountPaid?: { __typename?: 'MoneyData', currency: string, amount: number } | null, balance?: { __typename?: 'MoneyData', currency: string, amount: number } | null, freightChargeAmount?: { __typename?: 'MoneyData', currency: string, amount: number } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceDocument', contributions: Array<{ __typename?: 'LoadFreightContributionDocument', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, discountAmount: { __typename?: 'MoneyData', currency: string, amount: number } };

export type OrderPaymentsFragment = { __typename?: 'OrdersDocument', id: string, orderId: string, orderType: Types.OrderType, creditApplicationStatus?: Types.CreditApplicationStatus | null, paymentStatus: Types.PaymentStatus, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, amountPaid?: { __typename?: 'MoneyData', currency: string, amount: number } | null, balance?: { __typename?: 'MoneyData', currency: string, amount: number } | null, payments: Array<{ __typename?: 'OrderPaymentEntryDocument', kind: Types.OrderPaymentKind, source: Types.OrderPaymentSource, externalRemoteId?: string | null, occurredAt: Types.TDateISO, recordedBy?: string | null, paymentId?: string | null, paymentSyncStatus: Types.PaymentSyncStatus, accountingPaymentId?: string | null, syncFailureReason?: string | null, amount: { __typename?: 'MoneyData', currency: string, amount: number } }> };

export type OrderGridListFragment = { __typename?: 'OrdersDocument', id: string, orderId: string, orderNumber: string, poNumber: string, customerId: string, customerName: string, initializedDate: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, shippedDate?: Types.TDateISO | null, orderStatus: Types.OrderStatus, numberOfLines: number, freightChargeType?: number | null, freightChargeValue?: number | null, salesPerson?: string | null, syncDate?: Types.TDateISO | null, erpId?: string | null, orderType: Types.OrderType, finalCredit: boolean, termsId?: string | null, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number }, subtotal?: { __typename?: 'MoneyData', currency: string, amount: number } | null, freightChargeAmount?: { __typename?: 'MoneyData', currency: string, amount: number } | null, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> } };

export type OverAllocationWarningFragment = { __typename?: 'OverAllocationWarningData', itemId: string, locationId: string, grade: number, requestedQuantity: number, availableQuantity: number };

export type BulkAllocateLineShortfallFragment = { __typename?: 'BulkAllocateLineShortfall', lineItemId: string, itemId: string, orderedQuantity: number, allocatedQuantity: number, shortByQuantity: number, shippingUomLabel?: string | null, orderedUnits?: number | null, allocatedUnits?: number | null, shortByUnits?: number | null };

export type BulkAllocateSkippedLineFragment = { __typename?: 'BulkAllocateSkippedLine', lineItemId: string, itemId: string, reason: Types.BulkAllocateLineSkipReason };

export type BulkAllocateOrderResultFragment = { __typename?: 'BulkAllocateOrderResult', orderId: string, outcome: Types.BulkAllocateOutcome, linesAllocated: number, skipReason?: Types.BulkAllocateSkipReason | null, message?: string | null, shortfalls: Array<{ __typename?: 'BulkAllocateLineShortfall', lineItemId: string, itemId: string, orderedQuantity: number, allocatedQuantity: number, shortByQuantity: number, shippingUomLabel?: string | null, orderedUnits?: number | null, allocatedUnits?: number | null, shortByUnits?: number | null }>, skippedLines: Array<{ __typename?: 'BulkAllocateSkippedLine', lineItemId: string, itemId: string, reason: Types.BulkAllocateLineSkipReason }>, warnings: Array<{ __typename?: 'OverAllocationWarningData', itemId: string, locationId: string, grade: number, requestedQuantity: number, availableQuantity: number }> };

export type OrderFlatChargeFragment = { __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string };

export type OrderDetailsFragment = { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit: Types.PriceEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, program?: string | null, orderKindId?: string | null, orderKindName?: string | null, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', counterpartOrderId: string, role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', unitPrice: number, overrideUnitPrice?: number | null, acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, pulls: Array<{ __typename?: 'OrderLinePull', pullId: string, lineItemId: string, itemId: string, locationId: string, locationName?: string | null, grade: number, quantity: number, pulledBy: string, pulledAt: Types.TDateISO }>, allocationTakes: Array<{ __typename?: 'OrderAllocationTake', lineItemId: string, itemId: string, itemName?: string | null, locationId: string, locationName?: string | null, grade: number, quantity: number, direction: Types.AllocationTakeDirection, otherOrderId: string, otherOrderNumber?: string | null, otherCustomerName?: string | null, allocatedBefore?: number | null, allocatedAfter?: number | null, takenBy: string, takenAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null };

export type GetOrderVerificationQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderVerificationQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', orderId: string, verification?: { __typename?: 'OrderVerificationDetail', state: Types.OrderVerificationState, verifiedBy?: string | null, verifiedAt?: Types.TDateISO | null, recountReason?: string | null, lines: Array<{ __typename?: 'OrderVerificationLine', orderLineNumber: number, countedQuantity: number, finalQuantity?: number | null }>, adjustments: Array<{ __typename?: 'OrderVerificationAdjustment', orderLineNumber: number, originalQuantity: number, newQuantity: number }>, containers: Array<{ __typename?: 'OrderVerificationContainer', containerId: string, drop: string, status: Types.VerifyContainerStatus, finishedBy?: string | null, finishedAt?: Types.TDateISO | null, removedBy?: string | null, removedAt?: Types.TDateISO | null, removedReason?: string | null }> } | null } | null };

export type OrderVerificationFragment = { __typename?: 'OrderVerificationDetail', state: Types.OrderVerificationState, verifiedBy?: string | null, verifiedAt?: Types.TDateISO | null, recountReason?: string | null, lines: Array<{ __typename?: 'OrderVerificationLine', orderLineNumber: number, countedQuantity: number, finalQuantity?: number | null }>, adjustments: Array<{ __typename?: 'OrderVerificationAdjustment', orderLineNumber: number, originalQuantity: number, newQuantity: number }>, containers: Array<{ __typename?: 'OrderVerificationContainer', containerId: string, drop: string, status: Types.VerifyContainerStatus, finishedBy?: string | null, finishedAt?: Types.TDateISO | null, removedBy?: string | null, removedAt?: Types.TDateISO | null, removedReason?: string | null }> };

export type OrderQuoteDetailsFragment = { __typename?: 'OrderStateData', orderId: string, status: Types.OrderStatus, quoteValidUntil?: string | null, followUp?: { __typename?: 'OrderQuoteFollowUpData', on: string, note?: string | null, assignee: string, done: boolean, setBy: string, setAt: Types.TDateISO } | null };

export type OrderQuoteFollowUpFragment = { __typename?: 'OrderQuoteFollowUpData', on: string, note?: string | null, assignee: string, done: boolean, setBy: string, setAt: Types.TDateISO };

export type QuoteFollowUpDueFragment = { __typename?: 'OrdersDocument', orderId: string, orderNumber: string, customerName: string, quoteValidUntil?: string | null, followUp?: { __typename?: 'OrderQuoteFollowUpDocument', on: string, note?: string | null } | null };

export type GetOrderQuoteDetailsQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderQuoteDetailsQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', orderId: string, status: Types.OrderStatus, quoteValidUntil?: string | null, followUp?: { __typename?: 'OrderQuoteFollowUpData', on: string, note?: string | null, assignee: string, done: boolean, setBy: string, setAt: Types.TDateISO } | null } | null };

export type GetMyQuoteFollowUpsDueQueryVariables = Types.Exact<{
  asOf: Types.Scalars['LocalDate']['input'];
  mine: Types.Scalars['Boolean']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMyQuoteFollowUpsDueQuery = { __typename?: 'Query', quoteFollowUpsDue?: { __typename?: 'QuoteFollowUpsDueConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string, customerName: string, quoteValidUntil?: string | null, followUp?: { __typename?: 'OrderQuoteFollowUpDocument', on: string, note?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type OrderCategoryVolumeExclusionFragment = { __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number };

export type OrderCategoryVolumeDiscountFragment = { __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> };

export type OrderVolumeDiscountFragment = { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> };

export type OrderNonDiscountableLineFragment = { __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number };

export type OrderDiscountComponentFragment = { __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number };

export type OrderCategoryVolumeProgressFragment = { __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> };

export type OrderVolumePoolProgressFragment = { __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string };

export type LineItemFragment = { __typename?: 'LineItemData', unitPrice: number, overrideUnitPrice?: number | null, acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> };

export type LineItemRoyaltyFragment = { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number };

export type OrderLineUpgradeFragment = { __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } };

export type OrderTaxEstimateSummaryFragment = { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> };

export type OrderInvoiceLinkFieldsFragment = { __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number };

export type OrderLocationFragment = { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, poRequired?: boolean | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> };

export type RoutableOrderFragment = { __typename?: 'OrdersDocument', orderId: string, orderNumber: string, poNumber: string, program?: string | null, orderKindName?: string | null, customerName: string, orderStatus: Types.OrderStatus, expectedDeliveryDate: Types.TDateISO, plannedShipDate?: Types.TDateISO | null, weekNumber: number, numberOfLines: number, route?: string | null, effectiveRoute?: string | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, name: string, storeNumber: string }, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null };

export type OrderDropShipDestinationFieldsFragment = { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null };

export type GetRoutableOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.OrdersDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.OrdersDocumentSortInput> | Types.OrdersDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRoutableOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string, poNumber: string, program?: string | null, orderKindName?: string | null, customerName: string, orderStatus: Types.OrderStatus, expectedDeliveryDate: Types.TDateISO, plannedShipDate?: Types.TDateISO | null, weekNumber: number, numberOfLines: number, route?: string | null, effectiveRoute?: string | null, locations: { __typename?: 'OrderLocationDocumentData', id: string, name: string, storeNumber: string }, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrderMinimumOverridesQueryVariables = Types.Exact<{
  where: Types.OrderLineItemDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetOrderMinimumOverridesQuery = { __typename?: 'Query', orderLineItems?: { __typename?: 'OrderLineItemsConnection', nodes?: Array<{ __typename?: 'OrderLineItemDocument', lineNumber: number, minimumOverrideReason?: string | null }> | null } | null };

export type GetEarlierCreditsQueryVariables = Types.Exact<{
  where: Types.OrdersDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetEarlierCreditsQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'OrdersDocument', orderId: string, orderNumber: string, customerName: string, orderTotal: { __typename?: 'MoneyData', currency: string, amount: number } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetOrderContainerRequirementQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderContainerRequirementQuery = { __typename?: 'Query', orderContainerRequirement?: { __typename?: 'OrderContainerRequirement', goodsWeightLbs: number, orderContainerCode?: string | null, orderId: string, totalWeightComplete: boolean, totalWeightLbs: number, uncountedLineCount: number, unweighedLineCount: number, usedOrderContainer: boolean, byContainer: Array<{ __typename?: 'OrderContainerTotal', containerCode: string, containerName: string, fraction: number, needed: number, weightEachLbs?: number | null }>, uncountedLines: Array<{ __typename?: 'OrderUncountedLine', itemId: string, lineItemId: string, lineNumber: number, name: string, quantity: number, reason: Types.OrderUncountedLineReason, shippingUomCode?: string | null }>, unweighedContainers: Array<{ __typename?: 'OrderUnweighedContainer', containerCode: string, containerName: string, needed: number, reason: Types.OrderUnweighedContainerReason }>, unweighedLines: Array<{ __typename?: 'OrderUnweighedLine', itemId: string, lineItemId: string, lineNumber: number, name: string, quantity: number, reason: Types.OrderUnweighedLineReason }> } | null };

export type GetOrderContainerRequirementsQueryVariables = Types.Exact<{
  orderIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type GetOrderContainerRequirementsQuery = { __typename?: 'Query', orderContainerRequirements: Array<{ __typename?: 'OrderContainerRequirement', orderId: string, uncountedLineCount: number, byContainer: Array<{ __typename?: 'OrderContainerTotal', containerCode: string, containerName: string, needed: number }> }> };

export type GetOrderDeliveryStatusQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderDeliveryStatusQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', expectedDeliveryDate: Types.TDateISO, orderId: string, status: Types.OrderStatus } | null };

export type GetOrderDeliveryBillingLinesQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderDeliveryBillingLinesQuery = { __typename?: 'Query', order?: { __typename?: 'OrderStateData', orderId: string, lineItems: Array<{ __typename?: 'LineItemData', billableEaches: number, id: string, name: string, overridePrice?: number | null, price: number }> } | null };

export type LineItemDeliveryBillingFragment = { __typename?: 'LineItemData', billableEaches: number, id: string, name: string, overridePrice?: number | null, price: number };

export type GetDepositWriteBackCapabilityQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetDepositWriteBackCapabilityQuery = { __typename?: 'Query', depositWriteBackCapability: { __typename?: 'DepositWriteBackCapabilityPayload', supported: boolean, unsupportedReason?: string | null } };

export const OrderAllocationDepositFragmentDoc = new TypedDocumentString(`
    fragment OrderAllocationDeposit on OrdersDocument {
  depositRequired
  depositReceived
  depositSatisfied
}
    `, {"fragmentName":"OrderAllocationDeposit"});
export const EffectiveOrderNoteFragmentDoc = new TypedDocumentString(`
    fragment EffectiveOrderNote on EffectiveOrderNote {
  context
  source
  text
}
    `, {"fragmentName":"EffectiveOrderNote"});
export const OrderCorrectionLinkFragmentDoc = new TypedDocumentString(`
    fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
    `, {"fragmentName":"OrderCorrectionLink"});
export const OrderCreditsFragmentDoc = new TypedDocumentString(`
    fragment OrderCredits on OrdersDocument {
  id
  orderId
  orderType
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  credits {
    creditOrderId
    creditOrderNumber
    creditedAt
    amount {
      ...MoneyAmount
    }
    reason
  }
  creditedTotal {
    ...MoneyAmount
  }
  netAfterCredits {
    ...MoneyAmount
  }
}
    fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}`, {"fragmentName":"OrderCredits"});
export const LocationSalesPersonDetailsFragmentDoc = new TypedDocumentString(`
    fragment LocationSalesPersonDetails on LocationsSalesPersonDocument {
  id
  tenantId
  customerId
  locationId
  name
  erpId
  code
  salesPersonEmails
}
    `, {"fragmentName":"LocationSalesPersonDetails"});
export const OrderLocationFragmentDoc = new TypedDocumentString(`
    fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
    fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`, {"fragmentName":"OrderLocation"});
export const OrderSummaryFragmentDoc = new TypedDocumentString(`
    fragment OrderSummary on OrdersDocument {
  id
  tenantId
  orderId
  orderNumber
  poNumber
  customerId
  customerName
  initializedDate
  expectedDeliveryDate
  shippedDate
  orderStatus
  numberOfLines
  orderTotal {
    currency
    amount
  }
  subtotal {
    ...MoneyAmount
  }
  paymentStatus
  amountPaid {
    ...MoneyAmount
  }
  balance {
    ...MoneyAmount
  }
  freightChargeType
  freightChargeValue
  freightChargeAmount {
    ...MoneyAmount
  }
  freightAdjustedBy
  freightAdjustedAt
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  salesPerson
  syncDate
  confirmationEmail {
    sent
    toEmail
  }
  erpId
  orderType
  orderEntryUnit
  finalCredit
  termsId
  history
  locations {
    ...OrderLocation
  }
  billingAddress {
    ...AddressData
  }
  itemIds
  adjustedAt
  adjustedBy
  discountAmount {
    currency
    amount
  }
  discountPercent
  discountReason
}
    fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`, {"fragmentName":"OrderSummary"});
export const OrderPaymentsFragmentDoc = new TypedDocumentString(`
    fragment OrderPayments on OrdersDocument {
  id
  orderId
  orderType
  creditApplicationStatus
  orderTotal {
    ...MoneyAmount
  }
  paymentStatus
  amountPaid {
    ...MoneyAmount
  }
  balance {
    ...MoneyAmount
  }
  payments {
    kind
    amount {
      ...MoneyAmount
    }
    source
    externalRemoteId
    occurredAt
    recordedBy
    paymentId
    paymentSyncStatus
    accountingPaymentId
    syncFailureReason
  }
}
    fragment MoneyAmount on MoneyData {
  currency
  amount
}`, {"fragmentName":"OrderPayments"});
export const OrderGridListFragmentDoc = new TypedDocumentString(`
    fragment OrderGridList on OrdersDocument {
  id
  orderId
  orderNumber
  poNumber
  customerId
  customerName
  initializedDate
  expectedDeliveryDate
  shippedDate
  orderStatus
  numberOfLines
  orderTotal {
    currency
    amount
  }
  subtotal {
    ...MoneyAmount
  }
  freightChargeType
  freightChargeValue
  freightChargeAmount {
    ...MoneyAmount
  }
  salesPerson
  syncDate
  confirmationEmail {
    sent
    toEmail
  }
  erpId
  orderType
  finalCredit
  termsId
  locations {
    ...OrderLocation
  }
}
    fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`, {"fragmentName":"OrderGridList"});
export const BulkAllocateLineShortfallFragmentDoc = new TypedDocumentString(`
    fragment BulkAllocateLineShortfall on BulkAllocateLineShortfall {
  lineItemId
  itemId
  orderedQuantity
  allocatedQuantity
  shortByQuantity
  shippingUomLabel
  orderedUnits
  allocatedUnits
  shortByUnits
}
    `, {"fragmentName":"BulkAllocateLineShortfall"});
export const BulkAllocateSkippedLineFragmentDoc = new TypedDocumentString(`
    fragment BulkAllocateSkippedLine on BulkAllocateSkippedLine {
  lineItemId
  itemId
  reason
}
    `, {"fragmentName":"BulkAllocateSkippedLine"});
export const OverAllocationWarningFragmentDoc = new TypedDocumentString(`
    fragment OverAllocationWarning on OverAllocationWarningData {
  itemId
  locationId
  grade
  requestedQuantity
  availableQuantity
}
    `, {"fragmentName":"OverAllocationWarning"});
export const BulkAllocateOrderResultFragmentDoc = new TypedDocumentString(`
    fragment BulkAllocateOrderResult on BulkAllocateOrderResult {
  orderId
  outcome
  linesAllocated
  skipReason
  message
  shortfalls {
    ...BulkAllocateLineShortfall
  }
  skippedLines {
    ...BulkAllocateSkippedLine
  }
  warnings {
    ...OverAllocationWarning
  }
}
    fragment OverAllocationWarning on OverAllocationWarningData {
  itemId
  locationId
  grade
  requestedQuantity
  availableQuantity
}
fragment BulkAllocateLineShortfall on BulkAllocateLineShortfall {
  lineItemId
  itemId
  orderedQuantity
  allocatedQuantity
  shortByQuantity
  shippingUomLabel
  orderedUnits
  allocatedUnits
  shortByUnits
}
fragment BulkAllocateSkippedLine on BulkAllocateSkippedLine {
  lineItemId
  itemId
  reason
}`, {"fragmentName":"BulkAllocateOrderResult"});
export const OrderFlatChargeFragmentDoc = new TypedDocumentString(`
    fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
    `, {"fragmentName":"OrderFlatCharge"});
export const OrderTaxEstimateSummaryFragmentDoc = new TypedDocumentString(`
    fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
    `, {"fragmentName":"OrderTaxEstimateSummary"});
export const OrderInvoiceLinkFieldsFragmentDoc = new TypedDocumentString(`
    fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
    `, {"fragmentName":"OrderInvoiceLinkFields"});
export const OrderCategoryVolumeExclusionFragmentDoc = new TypedDocumentString(`
    fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
    `, {"fragmentName":"OrderCategoryVolumeExclusion"});
export const OrderCategoryVolumeDiscountFragmentDoc = new TypedDocumentString(`
    fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
    fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}`, {"fragmentName":"OrderCategoryVolumeDiscount"});
export const OrderCategoryVolumeProgressFragmentDoc = new TypedDocumentString(`
    fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
    fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}`, {"fragmentName":"OrderCategoryVolumeProgress"});
export const OrderVolumePoolProgressFragmentDoc = new TypedDocumentString(`
    fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
    `, {"fragmentName":"OrderVolumePoolProgress"});
export const OrderVolumeDiscountFragmentDoc = new TypedDocumentString(`
    fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
    `, {"fragmentName":"OrderVolumeDiscount"});
export const OrderNonDiscountableLineFragmentDoc = new TypedDocumentString(`
    fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
    `, {"fragmentName":"OrderNonDiscountableLine"});
export const OrderDiscountComponentFragmentDoc = new TypedDocumentString(`
    fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
    `, {"fragmentName":"OrderDiscountComponent"});
export const LineItemRoyaltyFragmentDoc = new TypedDocumentString(`
    fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
    `, {"fragmentName":"LineItemRoyalty"});
export const OrderLineUpgradeFragmentDoc = new TypedDocumentString(`
    fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
    `, {"fragmentName":"OrderLineUpgrade"});
export const LineItemFragmentDoc = new TypedDocumentString(`
    fragment LineItem on LineItemData {
  unitPrice
  overrideUnitPrice
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
    fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}`, {"fragmentName":"LineItem"});
export const OrderDropShipDestinationFieldsFragmentDoc = new TypedDocumentString(`
    fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}
    `, {"fragmentName":"OrderDropShipDestinationFields"});
export const OrderDetailsFragmentDoc = new TypedDocumentString(`
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  priceEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
    counterpartOrderId
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  program
  orderKindId
  orderKindName
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  pulls {
    pullId
    lineItemId
    itemId
    locationId
    locationName
    grade
    quantity
    pulledBy
    pulledAt
  }
  allocationTakes {
    lineItemId
    itemId
    itemName
    locationId
    locationName
    grade
    quantity
    direction
    otherOrderId
    otherOrderNumber
    otherCustomerName
    allocatedBefore
    allocatedAfter
    takenBy
    takenAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
    fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment LineItem on LineItemData {
  unitPrice
  overrideUnitPrice
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`, {"fragmentName":"OrderDetails"});
export const OrderVerificationFragmentDoc = new TypedDocumentString(`
    fragment OrderVerification on OrderVerificationDetail {
  state
  verifiedBy
  verifiedAt
  recountReason
  lines {
    orderLineNumber
    countedQuantity
    finalQuantity
  }
  adjustments {
    orderLineNumber
    originalQuantity
    newQuantity
  }
  containers {
    containerId
    drop
    status
    finishedBy
    finishedAt
    removedBy
    removedAt
    removedReason
  }
}
    `, {"fragmentName":"OrderVerification"});
export const OrderQuoteFollowUpFragmentDoc = new TypedDocumentString(`
    fragment OrderQuoteFollowUp on OrderQuoteFollowUpData {
  on
  note
  assignee
  done
  setBy
  setAt
}
    `, {"fragmentName":"OrderQuoteFollowUp"});
export const OrderQuoteDetailsFragmentDoc = new TypedDocumentString(`
    fragment OrderQuoteDetails on OrderStateData {
  orderId
  status
  quoteValidUntil
  followUp {
    ...OrderQuoteFollowUp
  }
}
    fragment OrderQuoteFollowUp on OrderQuoteFollowUpData {
  on
  note
  assignee
  done
  setBy
  setAt
}`, {"fragmentName":"OrderQuoteDetails"});
export const QuoteFollowUpDueFragmentDoc = new TypedDocumentString(`
    fragment QuoteFollowUpDue on OrdersDocument {
  orderId
  orderNumber
  customerName
  quoteValidUntil
  followUp {
    on
    note
  }
}
    `, {"fragmentName":"QuoteFollowUpDue"});
export const RoutableOrderFragmentDoc = new TypedDocumentString(`
    fragment RoutableOrder on OrdersDocument {
  orderId
  orderNumber
  poNumber
  program
  orderKindName
  customerName
  orderStatus
  expectedDeliveryDate
  plannedShipDate
  weekNumber
  numberOfLines
  route
  effectiveRoute
  locations {
    id
    name
    storeNumber
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
}
    fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}`, {"fragmentName":"RoutableOrder"});
export const LineItemDeliveryBillingFragmentDoc = new TypedDocumentString(`
    fragment LineItemDeliveryBilling on LineItemData {
  billableEaches
  id
  name
  overridePrice
  price
}
    `, {"fragmentName":"LineItemDeliveryBilling"});
export const GetCustomerNameDocument = new TypedDocumentString(`
    query GetCustomerName($customerId: String!) {
  customer(customerId: $customerId) {
    customerId
    name
  }
}
    `);
export const GetItemNameDocument = new TypedDocumentString(`
    query GetItemName($itemId: String!) {
  item(itemId: $itemId) {
    itemId
    name
  }
}
    `);
export const GetOrderDocument = new TypedDocumentString(`
    query GetOrder($orderId: String!) {
  order(orderId: $orderId) {
    ...OrderDetails
    revision
  }
}
    fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  priceEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
    counterpartOrderId
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  program
  orderKindId
  orderKindName
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  pulls {
    pullId
    lineItemId
    itemId
    locationId
    locationName
    grade
    quantity
    pulledBy
    pulledAt
  }
  allocationTakes {
    lineItemId
    itemId
    itemName
    locationId
    locationName
    grade
    quantity
    direction
    otherOrderId
    otherOrderNumber
    otherCustomerName
    allocatedBefore
    allocatedAfter
    takenBy
    takenAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment LineItem on LineItemData {
  unitPrice
  overrideUnitPrice
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`);
export const GetOrderPriceEntryUnitDocument = new TypedDocumentString(`
    query GetOrderPriceEntryUnit($orderId: String!) {
  order(orderId: $orderId) {
    orderId
    priceEntryUnit
  }
}
    `);
export const GetOrderLineCurrenciesDocument = new TypedDocumentString(`
    query GetOrderLineCurrencies($orderId: String!) {
  order(orderId: $orderId) {
    orderId
    lineItems {
      currency
    }
  }
}
    `);
export const GetOrderStatusDocument = new TypedDocumentString(`
    query GetOrderStatus($orderId: String!) {
  order(orderId: $orderId) {
    orderId
    status
  }
}
    `);
export const GetOrderHistoryDocument = new TypedDocumentString(`
    query GetOrderHistory($orderId: String!) {
  orderHistory(orderId: $orderId) {
    id
    label
    occurredAt
    occurredBy
  }
}
    `);
export const GetOrderInspectionDocument = new TypedDocumentString(`
    query GetOrderInspection($orderId: String!) {
  orderInspection(orderId: $orderId) {
    outcome
    order {
      orderId
      orderNumber
      type
      creditedFromOrderId
      correction {
        ...OrderCorrectionLink
        counterpartOrderId
        newCustomerId
      }
    }
  }
}
    fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}`);
export const GetOrderRouteInspectionDocument = new TypedDocumentString(`
    query GetOrderRouteInspection($orderId: String!) {
  orderInspection(orderId: $orderId) {
    outcome
    order {
      orderId
      route
    }
  }
}
    `);
export const GetOrderNumbersForHistoryDocument = new TypedDocumentString(`
    query GetOrderNumbersForHistory($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String) {
  orders(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      orderId
      orderNumber
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetOrderDepositStatusDocument = new TypedDocumentString(`
    query GetOrderDepositStatus($where: OrdersDocumentFilterInput!, $first: Int!) {
  orders(where: $where, first: $first) {
    nodes {
      orderId
      depositRequired
      depositReceived
      depositSatisfied
      allocationStatus
      lastAllocatedDate
    }
  }
}
    `);
export const GetOrdersForAllocationMoveDocument = new TypedDocumentString(`
    query GetOrdersForAllocationMove($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String) {
  orders(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...OrderSummary
      ...OrderAllocationDeposit
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment OrderAllocationDeposit on OrdersDocument {
  depositRequired
  depositReceived
  depositSatisfied
}
fragment OrderSummary on OrdersDocument {
  id
  tenantId
  orderId
  orderNumber
  poNumber
  customerId
  customerName
  initializedDate
  expectedDeliveryDate
  shippedDate
  orderStatus
  numberOfLines
  orderTotal {
    currency
    amount
  }
  subtotal {
    ...MoneyAmount
  }
  paymentStatus
  amountPaid {
    ...MoneyAmount
  }
  balance {
    ...MoneyAmount
  }
  freightChargeType
  freightChargeValue
  freightChargeAmount {
    ...MoneyAmount
  }
  freightAdjustedBy
  freightAdjustedAt
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  salesPerson
  syncDate
  confirmationEmail {
    sent
    toEmail
  }
  erpId
  orderType
  orderEntryUnit
  finalCredit
  termsId
  history
  locations {
    ...OrderLocation
  }
  billingAddress {
    ...AddressData
  }
  itemIds
  adjustedAt
  adjustedBy
  discountAmount {
    currency
    amount
  }
  discountPercent
  discountReason
}
fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`);
export const GetOrdersForKitOrderImportDocument = new TypedDocumentString(`
    query GetOrdersForKitOrderImport($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String) {
  orders(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      orderId
      orderNumber
      poNumber
      customerName
      orderStatus
      shipFromSiteLocationId
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetOrderEffectiveNotesDocument = new TypedDocumentString(`
    query GetOrderEffectiveNotes($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orders(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      orderId
      effectiveNotes {
        ...EffectiveOrderNote
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment EffectiveOrderNote on EffectiveOrderNote {
  context
  source
  text
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetOrderPaymentsDocument = new TypedDocumentString(`
    query GetOrderPayments($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orders(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...OrderPayments
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment OrderPayments on OrdersDocument {
  id
  orderId
  orderType
  creditApplicationStatus
  orderTotal {
    ...MoneyAmount
  }
  paymentStatus
  amountPaid {
    ...MoneyAmount
  }
  balance {
    ...MoneyAmount
  }
  payments {
    kind
    amount {
      ...MoneyAmount
    }
    source
    externalRemoteId
    occurredAt
    recordedBy
    paymentId
    paymentSyncStatus
    accountingPaymentId
    syncFailureReason
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}`);
export const GetOrderCreditsDocument = new TypedDocumentString(`
    query GetOrderCredits($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orders(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...OrderCredits
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderCredits on OrdersDocument {
  id
  orderId
  orderType
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
  }
  credits {
    creditOrderId
    creditOrderNumber
    creditedAt
    amount {
      ...MoneyAmount
    }
    reason
  }
  creditedTotal {
    ...MoneyAmount
  }
  netAfterCredits {
    ...MoneyAmount
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}`);
export const GetLineItemActualQuantitiesDocument = new TypedDocumentString(`
    query GetLineItemActualQuantities($orderId: String!) {
  lineItemActualQuantities(orderId: $orderId) {
    orderId
    lineItemId
    itemId
    locationId
    grade
    availableQuantity
    reservedQuantity
    actualQuantity
  }
}
    `);
export const GetLineItemActualQuantitiesByLocationGradeDocument = new TypedDocumentString(`
    query GetLineItemActualQuantitiesByLocationGrade($orderId: String!) {
  lineItemActualQuantitiesByLocationGrade(orderId: $orderId) {
    orderId
    lineItemId
    itemId
    locationId
    grade
    availableQuantity
    reservedQuantity
    actualQuantity
  }
}
    `);
export const GetLocationsByIdsDocument = new TypedDocumentString(`
    query GetLocationsByIds($where: LocationDocumentFilterInput!) {
  locations(where: $where) {
    nodes {
      id
      name
    }
  }
}
    `);
export const GetOrdersDocument = new TypedDocumentString(`
    query GetOrders($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orders(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...OrderSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment OrderSummary on OrdersDocument {
  id
  tenantId
  orderId
  orderNumber
  poNumber
  customerId
  customerName
  initializedDate
  expectedDeliveryDate
  shippedDate
  orderStatus
  numberOfLines
  orderTotal {
    currency
    amount
  }
  subtotal {
    ...MoneyAmount
  }
  paymentStatus
  amountPaid {
    ...MoneyAmount
  }
  balance {
    ...MoneyAmount
  }
  freightChargeType
  freightChargeValue
  freightChargeAmount {
    ...MoneyAmount
  }
  freightAdjustedBy
  freightAdjustedAt
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  salesPerson
  syncDate
  confirmationEmail {
    sent
    toEmail
  }
  erpId
  orderType
  orderEntryUnit
  finalCredit
  termsId
  history
  locations {
    ...OrderLocation
  }
  billingAddress {
    ...AddressData
  }
  itemIds
  adjustedAt
  adjustedBy
  discountAmount {
    currency
    amount
  }
  discountPercent
  discountReason
}
fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`);
export const GetOrdersGridListDocument = new TypedDocumentString(`
    query GetOrdersGridList($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  orders(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...OrderGridList
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment OrderGridList on OrdersDocument {
  id
  orderId
  orderNumber
  poNumber
  customerId
  customerName
  initializedDate
  expectedDeliveryDate
  shippedDate
  orderStatus
  numberOfLines
  orderTotal {
    currency
    amount
  }
  subtotal {
    ...MoneyAmount
  }
  freightChargeType
  freightChargeValue
  freightChargeAmount {
    ...MoneyAmount
  }
  salesPerson
  syncDate
  confirmationEmail {
    sent
    toEmail
  }
  erpId
  orderType
  finalCredit
  termsId
  locations {
    ...OrderLocation
  }
}
fragment OrderLocation on OrderLocationDocumentData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  poRequired
  priceGroupId
  priceGroupName
  termsId
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`);
export const GetOrderLocationsDocument = new TypedDocumentString(`
    query GetOrderLocations($first: Int, $after: String, $order: [LocationsSalesPersonDocumentSortInput!], $where: LocationsSalesPersonDocumentFilterInput) {
  locationsSalesPeople(first: $first, after: $after, order: $order, where: $where) {
    nodes {
      ...LocationSalesPersonDetails
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LocationSalesPersonDetails on LocationsSalesPersonDocument {
  id
  tenantId
  customerId
  locationId
  name
  erpId
  code
  salesPersonEmails
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetLocationSalesPeopleDocument = new TypedDocumentString(`
    query GetLocationSalesPeople($first: Int, $after: String, $order: [LocationsSalesPersonDocumentSortInput!], $where: LocationsSalesPersonDocumentFilterInput) {
  locationsSalesPeople(first: $first, after: $after, order: $order, where: $where) {
    nodes {
      ...LocationSalesPersonDetails
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LocationSalesPersonDetails on LocationsSalesPersonDocument {
  id
  tenantId
  customerId
  locationId
  name
  erpId
  code
  salesPersonEmails
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetOrderDetailsPdfDocument = new TypedDocumentString(`
    query GetOrderDetailsPdf($orderId: String!) {
  orderDetailsPdf(orderId: $orderId) {
    base64Pdf
    orderId
  }
}
    `);
export const GetShippingAcknowledgmentPdfDocument = new TypedDocumentString(`
    query GetShippingAcknowledgmentPdf($orderId: String!) {
  shippingAcknowledgmentPdf(orderId: $orderId) {
    base64Pdf
    orderId
  }
}
    `);
export const GetOrderAddressEditPermissionsDocument = new TypedDocumentString(`
    query GetOrderAddressEditPermissions($customerId: String!, $locationId: UUID) {
  orderAddressEditPermissions(customerId: $customerId, locationId: $locationId) {
    billingAddressEditable
    locationAddressEditable
  }
}
    `);
export const OrderCustomerLocationPoRequiredInheritedDocument = new TypedDocumentString(`
    query OrderCustomerLocationPoRequiredInherited($locationId: UUID!) {
  customerLocationPoRequiredInherited(locationId: $locationId)
}
    `);
export const GetOrderVerificationDocument = new TypedDocumentString(`
    query GetOrderVerification($orderId: String!) {
  order(orderId: $orderId) {
    orderId
    verification {
      ...OrderVerification
    }
  }
}
    fragment OrderVerification on OrderVerificationDetail {
  state
  verifiedBy
  verifiedAt
  recountReason
  lines {
    orderLineNumber
    countedQuantity
    finalQuantity
  }
  adjustments {
    orderLineNumber
    originalQuantity
    newQuantity
  }
  containers {
    containerId
    drop
    status
    finishedBy
    finishedAt
    removedBy
    removedAt
    removedReason
  }
}`);
export const GetOrderQuoteDetailsDocument = new TypedDocumentString(`
    query GetOrderQuoteDetails($orderId: String!) {
  order(orderId: $orderId) {
    ...OrderQuoteDetails
  }
}
    fragment OrderQuoteDetails on OrderStateData {
  orderId
  status
  quoteValidUntil
  followUp {
    ...OrderQuoteFollowUp
  }
}
fragment OrderQuoteFollowUp on OrderQuoteFollowUpData {
  on
  note
  assignee
  done
  setBy
  setAt
}`);
export const GetMyQuoteFollowUpsDueDocument = new TypedDocumentString(`
    query GetMyQuoteFollowUpsDue($asOf: LocalDate!, $mine: Boolean!, $first: Int, $after: String, $last: Int, $before: String) {
  quoteFollowUpsDue(
    asOf: $asOf
    mine: $mine
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...QuoteFollowUpDue
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment QuoteFollowUpDue on OrdersDocument {
  orderId
  orderNumber
  customerName
  quoteValidUntil
  followUp {
    on
    note
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetRoutableOrdersDocument = new TypedDocumentString(`
    query GetRoutableOrders($where: OrdersDocumentFilterInput, $order: [OrdersDocumentSortInput!], $first: Int, $after: String) {
  orders(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...RoutableOrder
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment RoutableOrder on OrdersDocument {
  orderId
  orderNumber
  poNumber
  program
  orderKindName
  customerName
  orderStatus
  expectedDeliveryDate
  plannedShipDate
  weekNumber
  numberOfLines
  route
  effectiveRoute
  locations {
    id
    name
    storeNumber
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetOrderMinimumOverridesDocument = new TypedDocumentString(`
    query GetOrderMinimumOverrides($where: OrderLineItemDocumentFilterInput!, $first: Int!) {
  orderLineItems(where: $where, first: $first) {
    nodes {
      lineNumber
      minimumOverrideReason
    }
  }
}
    `);
export const GetEarlierCreditsDocument = new TypedDocumentString(`
    query GetEarlierCredits($where: OrdersDocumentFilterInput!, $first: Int!) {
  orders(first: $first, where: $where) {
    nodes {
      orderId
      orderNumber
      customerName
      orderTotal {
        ...MoneyAmount
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}`);
export const GetOrderContainerRequirementDocument = new TypedDocumentString(`
    query GetOrderContainerRequirement($orderId: String!) {
  orderContainerRequirement(orderId: $orderId) {
    byContainer {
      containerCode
      containerName
      fraction
      needed
      weightEachLbs
    }
    goodsWeightLbs
    orderContainerCode
    orderId
    totalWeightComplete
    totalWeightLbs
    uncountedLineCount
    uncountedLines {
      itemId
      lineItemId
      lineNumber
      name
      quantity
      reason
      shippingUomCode
    }
    unweighedContainers {
      containerCode
      containerName
      needed
      reason
    }
    unweighedLineCount
    unweighedLines {
      itemId
      lineItemId
      lineNumber
      name
      quantity
      reason
    }
    usedOrderContainer
  }
}
    `);
export const GetOrderContainerRequirementsDocument = new TypedDocumentString(`
    query GetOrderContainerRequirements($orderIds: [String!]!) {
  orderContainerRequirements(orderIds: $orderIds) {
    byContainer {
      containerCode
      containerName
      needed
    }
    orderId
    uncountedLineCount
  }
}
    `);
export const GetOrderDeliveryStatusDocument = new TypedDocumentString(`
    query GetOrderDeliveryStatus($orderId: String!) {
  order(orderId: $orderId) {
    expectedDeliveryDate
    orderId
    status
  }
}
    `);
export const GetOrderDeliveryBillingLinesDocument = new TypedDocumentString(`
    query GetOrderDeliveryBillingLines($orderId: String!) {
  order(orderId: $orderId) {
    lineItems {
      ...LineItemDeliveryBilling
    }
    orderId
  }
}
    fragment LineItemDeliveryBilling on LineItemData {
  billableEaches
  id
  name
  overridePrice
  price
}`);
export const GetDepositWriteBackCapabilityDocument = new TypedDocumentString(`
    query GetDepositWriteBackCapability {
  depositWriteBackCapability {
    supported
    unsupportedReason
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerName: build.query<GetCustomerNameQuery, GetCustomerNameQueryVariables>({
      query: (variables) => ({ document: GetCustomerNameDocument, variables })
    }),
    GetItemName: build.query<GetItemNameQuery, GetItemNameQueryVariables>({
      query: (variables) => ({ document: GetItemNameDocument, variables })
    }),
    GetOrder: build.query<GetOrderQuery, GetOrderQueryVariables>({
      query: (variables) => ({ document: GetOrderDocument, variables })
    }),
    GetOrderPriceEntryUnit: build.query<GetOrderPriceEntryUnitQuery, GetOrderPriceEntryUnitQueryVariables>({
      query: (variables) => ({ document: GetOrderPriceEntryUnitDocument, variables })
    }),
    GetOrderLineCurrencies: build.query<GetOrderLineCurrenciesQuery, GetOrderLineCurrenciesQueryVariables>({
      query: (variables) => ({ document: GetOrderLineCurrenciesDocument, variables })
    }),
    GetOrderStatus: build.query<GetOrderStatusQuery, GetOrderStatusQueryVariables>({
      query: (variables) => ({ document: GetOrderStatusDocument, variables })
    }),
    GetOrderHistory: build.query<GetOrderHistoryQuery, GetOrderHistoryQueryVariables>({
      query: (variables) => ({ document: GetOrderHistoryDocument, variables })
    }),
    GetOrderInspection: build.query<GetOrderInspectionQuery, GetOrderInspectionQueryVariables>({
      query: (variables) => ({ document: GetOrderInspectionDocument, variables })
    }),
    GetOrderRouteInspection: build.query<GetOrderRouteInspectionQuery, GetOrderRouteInspectionQueryVariables>({
      query: (variables) => ({ document: GetOrderRouteInspectionDocument, variables })
    }),
    GetOrderNumbersForHistory: build.query<GetOrderNumbersForHistoryQuery, GetOrderNumbersForHistoryQueryVariables | void>({
      query: (variables) => ({ document: GetOrderNumbersForHistoryDocument, variables })
    }),
    GetOrderDepositStatus: build.query<GetOrderDepositStatusQuery, GetOrderDepositStatusQueryVariables>({
      query: (variables) => ({ document: GetOrderDepositStatusDocument, variables })
    }),
    GetOrdersForAllocationMove: build.query<GetOrdersForAllocationMoveQuery, GetOrdersForAllocationMoveQueryVariables | void>({
      query: (variables) => ({ document: GetOrdersForAllocationMoveDocument, variables })
    }),
    GetOrdersForKitOrderImport: build.query<GetOrdersForKitOrderImportQuery, GetOrdersForKitOrderImportQueryVariables | void>({
      query: (variables) => ({ document: GetOrdersForKitOrderImportDocument, variables })
    }),
    GetOrderEffectiveNotes: build.query<GetOrderEffectiveNotesQuery, GetOrderEffectiveNotesQueryVariables | void>({
      query: (variables) => ({ document: GetOrderEffectiveNotesDocument, variables })
    }),
    GetOrderPayments: build.query<GetOrderPaymentsQuery, GetOrderPaymentsQueryVariables | void>({
      query: (variables) => ({ document: GetOrderPaymentsDocument, variables })
    }),
    GetOrderCredits: build.query<GetOrderCreditsQuery, GetOrderCreditsQueryVariables | void>({
      query: (variables) => ({ document: GetOrderCreditsDocument, variables })
    }),
    GetLineItemActualQuantities: build.query<GetLineItemActualQuantitiesQuery, GetLineItemActualQuantitiesQueryVariables>({
      query: (variables) => ({ document: GetLineItemActualQuantitiesDocument, variables })
    }),
    GetLineItemActualQuantitiesByLocationGrade: build.query<GetLineItemActualQuantitiesByLocationGradeQuery, GetLineItemActualQuantitiesByLocationGradeQueryVariables>({
      query: (variables) => ({ document: GetLineItemActualQuantitiesByLocationGradeDocument, variables })
    }),
    GetLocationsByIds: build.query<GetLocationsByIdsQuery, GetLocationsByIdsQueryVariables>({
      query: (variables) => ({ document: GetLocationsByIdsDocument, variables })
    }),
    GetOrders: build.query<GetOrdersQuery, GetOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetOrdersDocument, variables })
    }),
    GetOrdersGridList: build.query<GetOrdersGridListQuery, GetOrdersGridListQueryVariables | void>({
      query: (variables) => ({ document: GetOrdersGridListDocument, variables })
    }),
    GetOrderLocations: build.query<GetOrderLocationsQuery, GetOrderLocationsQueryVariables | void>({
      query: (variables) => ({ document: GetOrderLocationsDocument, variables })
    }),
    GetLocationSalesPeople: build.query<GetLocationSalesPeopleQuery, GetLocationSalesPeopleQueryVariables | void>({
      query: (variables) => ({ document: GetLocationSalesPeopleDocument, variables })
    }),
    GetOrderDetailsPdf: build.query<GetOrderDetailsPdfQuery, GetOrderDetailsPdfQueryVariables>({
      query: (variables) => ({ document: GetOrderDetailsPdfDocument, variables })
    }),
    GetShippingAcknowledgmentPdf: build.query<GetShippingAcknowledgmentPdfQuery, GetShippingAcknowledgmentPdfQueryVariables>({
      query: (variables) => ({ document: GetShippingAcknowledgmentPdfDocument, variables })
    }),
    GetOrderAddressEditPermissions: build.query<GetOrderAddressEditPermissionsQuery, GetOrderAddressEditPermissionsQueryVariables>({
      query: (variables) => ({ document: GetOrderAddressEditPermissionsDocument, variables })
    }),
    OrderCustomerLocationPoRequiredInherited: build.query<OrderCustomerLocationPoRequiredInheritedQuery, OrderCustomerLocationPoRequiredInheritedQueryVariables>({
      query: (variables) => ({ document: OrderCustomerLocationPoRequiredInheritedDocument, variables })
    }),
    GetOrderVerification: build.query<GetOrderVerificationQuery, GetOrderVerificationQueryVariables>({
      query: (variables) => ({ document: GetOrderVerificationDocument, variables })
    }),
    GetOrderQuoteDetails: build.query<GetOrderQuoteDetailsQuery, GetOrderQuoteDetailsQueryVariables>({
      query: (variables) => ({ document: GetOrderQuoteDetailsDocument, variables })
    }),
    GetMyQuoteFollowUpsDue: build.query<GetMyQuoteFollowUpsDueQuery, GetMyQuoteFollowUpsDueQueryVariables>({
      query: (variables) => ({ document: GetMyQuoteFollowUpsDueDocument, variables })
    }),
    GetRoutableOrders: build.query<GetRoutableOrdersQuery, GetRoutableOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetRoutableOrdersDocument, variables })
    }),
    GetOrderMinimumOverrides: build.query<GetOrderMinimumOverridesQuery, GetOrderMinimumOverridesQueryVariables>({
      query: (variables) => ({ document: GetOrderMinimumOverridesDocument, variables })
    }),
    GetEarlierCredits: build.query<GetEarlierCreditsQuery, GetEarlierCreditsQueryVariables>({
      query: (variables) => ({ document: GetEarlierCreditsDocument, variables })
    }),
    GetOrderContainerRequirement: build.query<GetOrderContainerRequirementQuery, GetOrderContainerRequirementQueryVariables>({
      query: (variables) => ({ document: GetOrderContainerRequirementDocument, variables })
    }),
    GetOrderContainerRequirements: build.query<GetOrderContainerRequirementsQuery, GetOrderContainerRequirementsQueryVariables>({
      query: (variables) => ({ document: GetOrderContainerRequirementsDocument, variables })
    }),
    GetOrderDeliveryStatus: build.query<GetOrderDeliveryStatusQuery, GetOrderDeliveryStatusQueryVariables>({
      query: (variables) => ({ document: GetOrderDeliveryStatusDocument, variables })
    }),
    GetOrderDeliveryBillingLines: build.query<GetOrderDeliveryBillingLinesQuery, GetOrderDeliveryBillingLinesQueryVariables>({
      query: (variables) => ({ document: GetOrderDeliveryBillingLinesDocument, variables })
    }),
    GetDepositWriteBackCapability: build.query<GetDepositWriteBackCapabilityQuery, GetDepositWriteBackCapabilityQueryVariables | void>({
      query: (variables) => ({ document: GetDepositWriteBackCapabilityDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerNameQuery, useLazyGetCustomerNameQuery, useGetItemNameQuery, useLazyGetItemNameQuery, useGetOrderQuery, useLazyGetOrderQuery, useGetOrderPriceEntryUnitQuery, useLazyGetOrderPriceEntryUnitQuery, useGetOrderLineCurrenciesQuery, useLazyGetOrderLineCurrenciesQuery, useGetOrderStatusQuery, useLazyGetOrderStatusQuery, useGetOrderHistoryQuery, useLazyGetOrderHistoryQuery, useGetOrderInspectionQuery, useLazyGetOrderInspectionQuery, useGetOrderRouteInspectionQuery, useLazyGetOrderRouteInspectionQuery, useGetOrderNumbersForHistoryQuery, useLazyGetOrderNumbersForHistoryQuery, useGetOrderDepositStatusQuery, useLazyGetOrderDepositStatusQuery, useGetOrdersForAllocationMoveQuery, useLazyGetOrdersForAllocationMoveQuery, useGetOrdersForKitOrderImportQuery, useLazyGetOrdersForKitOrderImportQuery, useGetOrderEffectiveNotesQuery, useLazyGetOrderEffectiveNotesQuery, useGetOrderPaymentsQuery, useLazyGetOrderPaymentsQuery, useGetOrderCreditsQuery, useLazyGetOrderCreditsQuery, useGetLineItemActualQuantitiesQuery, useLazyGetLineItemActualQuantitiesQuery, useGetLineItemActualQuantitiesByLocationGradeQuery, useLazyGetLineItemActualQuantitiesByLocationGradeQuery, useGetLocationsByIdsQuery, useLazyGetLocationsByIdsQuery, useGetOrdersQuery, useLazyGetOrdersQuery, useGetOrdersGridListQuery, useLazyGetOrdersGridListQuery, useGetOrderLocationsQuery, useLazyGetOrderLocationsQuery, useGetLocationSalesPeopleQuery, useLazyGetLocationSalesPeopleQuery, useGetOrderDetailsPdfQuery, useLazyGetOrderDetailsPdfQuery, useGetShippingAcknowledgmentPdfQuery, useLazyGetShippingAcknowledgmentPdfQuery, useGetOrderAddressEditPermissionsQuery, useLazyGetOrderAddressEditPermissionsQuery, useOrderCustomerLocationPoRequiredInheritedQuery, useLazyOrderCustomerLocationPoRequiredInheritedQuery, useGetOrderVerificationQuery, useLazyGetOrderVerificationQuery, useGetOrderQuoteDetailsQuery, useLazyGetOrderQuoteDetailsQuery, useGetMyQuoteFollowUpsDueQuery, useLazyGetMyQuoteFollowUpsDueQuery, useGetRoutableOrdersQuery, useLazyGetRoutableOrdersQuery, useGetOrderMinimumOverridesQuery, useLazyGetOrderMinimumOverridesQuery, useGetEarlierCreditsQuery, useLazyGetEarlierCreditsQuery, useGetOrderContainerRequirementQuery, useLazyGetOrderContainerRequirementQuery, useGetOrderContainerRequirementsQuery, useLazyGetOrderContainerRequirementsQuery, useGetOrderDeliveryStatusQuery, useLazyGetOrderDeliveryStatusQuery, useGetOrderDeliveryBillingLinesQuery, useLazyGetOrderDeliveryBillingLinesQuery, useGetDepositWriteBackCapabilityQuery, useLazyGetDepositWriteBackCapabilityQuery } = injectedRtkApi;
